import { Component, OnInit } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { MenuController, NavController } from '@ionic/angular';
import { Storage } from '@ionic/storage';
import { Store } from '@ngrx/store';
import { Config } from 'merchandising-sdk';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { MenuProp } from './stores/menu/menu.prop';
import { Filesystem, Directory } from '@capacitor/filesystem';
import { MiscHelper } from './helpers/misc';
import { App } from '@capacitor/app';

import { UserProp } from './stores/user/user.prop';
import { setLogin } from './stores/user/user.actions';
import { setDataUpdates } from './stores/menu/menu.actions';
import { version } from 'src/version';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent implements OnInit {
  constructor(private nav: NavController
    , private storage: Storage
    , private menu: MenuController
    , private store: Store<{ menu: MenuProp, user: UserProp }>) { }

  public has_data_updates: boolean;
  public $menu: Observable<MenuProp>;
  public $user: Observable<UserProp>;
  public orders_count: number = 0;
  public is_data_updates_enabled: boolean;
  public has_manage_order: boolean = false;

  public settings: any = {
    logo: "/assets/logos/analyticsmart.png",
    has_orders: true,
    branding: "/assets/logos/analyticsmart.png",
    footer: {
      has_copyright: true
    }
  };
  public is_menu_enabled: boolean;
  public version: string;

  ngOnInit() {
    //  initialize config
    Config.IS_ONLINE = environment.is_online;
    if(!environment.is_online){
      this.is_data_updates_enabled = true;
    }

    //  initialize store
    this.$menu = this.store.select("menu");
    this.$user = this.store.select("user");

    //  subscribe to user
    this.$user.subscribe(async data => {
      const { is_login } = data;
      this.is_menu_enabled = is_login;
      if (is_login) {
        this.store.dispatch(setDataUpdates({has_data_updates: false}));
        this.checkRole();
      }
    });

    this.$menu.subscribe(async data => {
        this.has_data_updates = data.has_data_updates;
        if (!environment.is_online) {
          await this.setLocalAssetUrl();
        }
        if(data.has_data_updates){
          await this.setOrganizationSettings();
        }

        this.orders_count = data.orders_count;
    });

    this.init();
  }

  async init() {
    let storage = await this.storage.create();
    if (await storage.get('is_login')) {
      this.store.dispatch(setLogin({ is_login: true }));
    }
    await this.checkRole();
    await this.setOrganizationSettings();

    
    //  set app version
    try{
      const app_info = await App.getInfo();
      this.version = app_info.version;
    }catch(e){
      this.version = version.name
    }
  }

  async checkRole(){
    let storage = await this.storage.create();
    const role = await storage.get(`role`);
    if((role==='client_admin' || role==='manager') && environment.is_online){
      this.has_manage_order = true;
    }else{
      this.has_manage_order = false;
    }
  }

  async setOrganizationSettings() {
    const settings = await MiscHelper.getJson('/app/settings.json');
    if (settings) {
      if (settings.menu) {
        if (settings.menu.logo) {
          settings.menu.logo = await MiscHelper.getAssetUrl(`/app/${settings.menu.logo}`)
        }
        if (settings.menu.branding) {
          settings.menu.branding = await MiscHelper.getAssetUrl(`/app/${settings.menu.branding}`);
        }
      }
      let { menu } = settings;
      this.settings = menu;
    }
  }

  async setLocalAssetUrl() {
    let result = await Filesystem.getUri({
      path: 'repo',
      directory: Directory.Data
    });
    environment.assets_url = Capacitor.convertFileSrc(result.uri);
  }


  pushPage(url: string) {
    this.menu.close();
    this.nav.navigateForward(url);
  }

  rootPage(url: string) {
    this.menu.close();
    this.nav.navigateRoot(url);
  }

  async logout() {
    let storage = await this.storage.create();
    await storage.remove('is_login');
    await storage.remove(`role`);
    await this.menu.close();
    this.store.dispatch(setLogin({ is_login: false, user: null }));
    this.nav.navigateBack(`/auth/login`);
  }
}